module.exports = __webpack_public_path__ + "978662c81ccfea7b816e10c55ba91378.svg";